import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getQueryParam } from '../../genericUtils/analyticsUtils';
import { PaymentInfoSelected, PaymentState, ToasterNotification } from '@msc-b2c/interfaces/types';
import { mscGet, mscRemove } from '../../utilFuncs/mscStorageClient';

const isCard3dsReturn = getQueryParam('status_3d') === 'Y';
const isKlarnaReturn = !!(getQueryParam('status') && getQueryParam('datatransTrxId'));

const initialState: PaymentState = {
  is3dsFlow: isCard3dsReturn || isKlarnaReturn,
  is3dsPaymentSuccess: false,
  isErrorModalOpen: false,
};

function loadFromSessionStorage(key: string, defaultValue: PaymentState) {
  if (isCard3dsReturn || isKlarnaReturn) {
    const storedData = mscGet<unknown>('session', key);
    if (storedData === null) return defaultValue;
    mscRemove('session', key);
    return storedData as PaymentState;
  } else {
    return defaultValue;
  }
}

const payment = createSlice({
  name: 'payment',
  initialState: loadFromSessionStorage('paymentState', initialState),
  reducers: {
    payment3dsFlow: (state: PaymentState, action: PayloadAction<boolean>) => {
      state.is3dsFlow = action.payload;
    },
    errorModalOpen: (state: PaymentState, action: PayloadAction<boolean>) => {
      state.isErrorModalOpen = action.payload;
    },
    is3dsPaymentSuccess: (state: PaymentState, action: PayloadAction<boolean>) => {
      state.is3dsBookingSuccess = action.payload;
    },
    selectedPaymentInfo: (state: PaymentState, action: PayloadAction<PaymentInfoSelected>) => {
      state.selectedPayment = action.payload;
    },
  },
});

export const { is3dsPaymentSuccess, payment3dsFlow, errorModalOpen, selectedPaymentInfo } =
  payment.actions;
export default payment.reducer;
